import { render, staticRenderFns } from "./ProcHospitalariosView.vue?vue&type=template&id=b074c882"
import script from "./ProcHospitalariosView.vue?vue&type=script&lang=js"
export * from "./ProcHospitalariosView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports